export const fdefContractBulkAssignedClerk = {
  formdefinition: [
    {
      control: "autocomplete",
      name: "current_sachbearbeiter_id_ov",
      label: "Aktuell zugewiesener Sachbearbeiter",
      valid: "isNotEmpty(item)",
      multiple: false,
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint: "data/vertrags/assigned-clerks",
      },
    },
    {
      control: "autocomplete",
      name: "new_sachbearbeiter_id_ov",
      label: "Neuer Sachbearbeiter",
      valid: "isNotEmpty(item)",
      multiple: false,
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint: "data/vertrags/assignable-clerks",
      },
    },
  ],
  transformOut: [],
};
